export interface IObjectKeys {
  [key: string]: any;
}

export enum AuthSteps {
  STEP_WELCOME,
  STEP_REQUEST_CODE,
}
